export const APP_NAME = 'disco-ads';
export const APP_VERSION = '1.0.0';

export const WORKFLOW_IDS = {
  DISCO_RECOMMENDATIONS: 'disco.recommendations',
  DISCO_EVENTS: 'disco.events',
} as const;

export const DISPLAY_MODES = {
  PULLUP: 'PULLUP',
  INLINE: 'INLINE',
  OVERLAY: 'OVERLAY',
} as const;

export enum DiscoLayout {
  Drawer = 'DRAWER',
  Inline = 'INLINE',
  Cover = 'COVER',
}

export const VIEWS = {
  ORDER_TRACKING: 'ORDER_TRACKING',
  THANK_YOU: 'THANK_YOU',
} as const;

export const LAYOUT_IDS = {
  APP_NATIVE_ESSENTIAL: 'APP_NATIVE_ESSENTIAL_0.1',
} as const;

export const EVENT_NAMES = {
  WIDGET_LOAD: 'widget_load',
  WIDGET_DISPLAY: 'widget_display',
  WIDGET_VIEW: 'widget_view',
  AD_DISPLAY: 'ad_display',
  AD_VIEW: 'ad_view',
  AD_CLICK: 'ad_click',
  ELEMENT_CLICK: 'element_click',
  OFFER_TAB_BLOCKED: 'offer_tab_blocked',
  EMAIL_VALIDATION: 'email_validation',
} as const;

export const COVER_IMAGE_PARTNER_TEST_NAME = 'NARVAR_COVER_IMAGE_TEST';

export const BANNER_FORMAT_PARTNER_TEST_NAME = 'NARVAR_BANNER_FORMAT_TEST';

export const EDD_DRAWER_PARTNER_TEST_NAME = 'NARVAR_EDD_DRAWER_TEST';

export const CUSTOM_BRANDING_FLAG = 'rm-disco-cover-indigo';

export const CUSTOM_BRANDING_ARMS = ['CONTROL', 'INDIGO'] as const;

export const isCustomBrandingArm = (
  value: unknown,
): value is (typeof CUSTOM_BRANDING_ARMS)[number] =>
  CUSTOM_BRANDING_ARMS.some((arm) => arm === value);

export const CUSTOM_BRANDING_GRADIENT_START = '#400d68';

export const EDD_DRAWER_FLAG = 'rm-disco-edd-drawer';

export const EDD_DRAWER_ARMS = ['CONTROL', 'EDD'] as const;

export type EddDrawerArm = (typeof EDD_DRAWER_ARMS)[number];

export const isEddDrawerArm = (value: unknown): value is EddDrawerArm =>
  EDD_DRAWER_ARMS.some((arm) => arm === value);
